import { Component, OnInit } from '@angular/core';
import { ABCisTableModel, ColumnType } from 'src/app/components/abcis-table/abcis-table.component';
import { ABCisApi } from 'src/app/handlers/apiHandler.service';

@Component({
  selector: 'app-user-pool-group-config',
  standalone: false,
  templateUrl: './user-pool-group-config.component.html',
  styleUrls: ['./user-pool-group-config.component.scss']
})
export class UserPoolGroupConfigComponent implements OnInit {
  tableConfig: ABCisTableModel;

  constructor() { }

  ngOnInit() {
    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: 'user-pool-group',
        approxamateRowCount: 1000,
        anyParams: true

      },
      colConfig: [
        { field: 'userPoolGroupId', header: 'User Pool Group ID', type: ColumnType.String, isReadonly: true, isPrimary: true, notInForm: true },
        { field: 'userId', header: 'Name', type: ColumnType.MultiSelectComplex, setUrl: 'click-user/lookup' },
        { field: 'poolId', header: 'Pool Name', type: ColumnType.MultiSelectComplex, setUrl: 'pool-group/lookup/0' }
      ],
      addFormConfig: {
        header: 'Add User Pool Group'
      },
      isConfigurable: true,
      canEdit: false
    };
  }

}
